import React from "react";

// interfaces
import { IIconComponentProps } from "@/types/components/IconComponentProps";

function LoLiveLogoIcon({ textColor = "#040404", ...props }: IIconComponentProps<HTMLSpanElement>) {
  return (
    <span {...props}>
      <svg id="a" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 76.68 20.86">
        <path
          fill="#ec1f25"
          d="M19.95,0c.2,.06,.4,.13,.55,.29,.18,.17,.29,.38,.31,.63,0,.08,0,.16,0,.25,0,6.17,0,12.34,0,18.5,0,.37-.1,.69-.41,.92-.16,.13-.35,.2-.56,.2-.05,0-.1,0-.15,0-6.2,0-12.4,0-18.59,0-.43,0-.75-.15-.98-.52-.06-.11-.09-.23-.13-.34V.88c.05-.16,.09-.31,.19-.45C.37,.2,.6,.07,.88,0H19.95Z"
        />
        <path
          fill="#ec1f25"
          d="M8.07,11.9c0,1.24,.19,2.12,.64,2.94,.5,.92,1.23,1.61,2.19,2.04,.78,.35,1.6,.46,2.44,.41,.74-.04,1.44-.22,2.09-.58,.83-.46,1.47-1.11,1.89-1.96,.71-1.43,.77-2.9,.25-4.4-.33-.96-.92-1.74-1.77-2.31-1.18-.8-2.49-.97-3.87-.73-.85,.15-1.6,.52-2.24,1.1-1.12,1.02-1.59,2.33-1.62,3.49Z"
        />
        <path
          fill="#ec1f25"
          d="M3.46,9.4c0,1.61,0,3.21,0,4.82,0,.38,.03,.75,.13,1.12,.15,.56,.43,1.05,.9,1.4,.66,.5,1.42,.62,2.22,.53,.59-.06,1.17-.22,1.69-.52,.09-.05,.07-.07,.02-.12-.31-.35-.58-.73-.8-1.14-.05-.08-.09-.11-.18-.09-.22,.05-.44,.06-.67,.05-.54-.03-.92-.31-1.07-.8-.06-.21-.07-.42-.07-.64,0-3.31,0-6.61,0-9.92,0-.13-.03-.16-.16-.16-.62,0-1.24,0-1.86,0-.12,0-.16,.04-.16,.16,0,1.77,0,3.54,0,5.31Z"
        />
        <path fill="#ec1f25" d="M.88,0C.6,.07,.37,.2,.19,.43,.09,.57,.05,.73,0,.88V0H.88Z" />
        <path
          fill={textColor}
          d="M42.29,14.29c.86-2.32,1.72-4.63,2.57-6.94,.04-.11,.09-.14,.2-.14,.78,0,1.56,0,2.36,0-.04,.11-.08,.21-.12,.31-1.25,3.12-2.5,6.25-3.75,9.37-.04,.11-.09,.15-.22,.15-.73,0-1.45,0-2.18,0-.09,0-.13-.03-.16-.11-1.28-3.21-2.57-6.43-3.86-9.64,0-.02-.01-.04-.02-.07,.04-.03,.09-.02,.13-.02,.74,0,1.49,0,2.23,0,.11,0,.15,.04,.19,.14,.85,2.29,1.7,4.58,2.55,6.87,0,.03,.01,.05,.05,.08Z"
        />
        <path
          fill={textColor}
          d="M28.11,9.26c0-1.73,0-3.46,0-5.19,0-.12,.02-.15,.15-.15,.68,0,1.37,0,2.05,0,.13,0,.18,.02,.18,.17,0,3.28,0,6.56,0,9.84,0,.17,0,.34,.04,.51,.12,.51,.46,.77,1,.81,.25,.02,.5,0,.75-.07,.07-.02,.1,0,.13,.07,.19,.51,.37,1.02,.57,1.53,.03,.08,.01,.11-.06,.14-.78,.32-1.58,.47-2.42,.34-1.14-.18-1.97-.86-2.26-2.04-.08-.32-.11-.64-.11-.97,0-1.66,0-3.32,0-4.98Z"
        />
        <path
          fill={textColor}
          d="M34.03,12.11c0-1.59,0-3.17,0-4.76,0-.11,.02-.15,.15-.15,.69,0,1.39,0,2.08,0,.13,0,.15,.04,.15,.15,0,3.18,0,6.36,0,9.54,0,.11-.02,.15-.14,.15-.7,0-1.4,0-2.09,0-.12,0-.14-.04-.14-.15,0-1.59,0-3.18,0-4.77Z"
        />
        <path
          fill="#ec1f25"
          d="M22.89,8.88c0-.87,.72-1.58,1.58-1.57,.87,0,1.57,.71,1.57,1.58,0,.86-.72,1.57-1.58,1.57-.86,0-1.57-.72-1.56-1.59Z"
        />
        <path
          fill="#ec1f25"
          d="M22.89,15.65c.01-.88,.72-1.57,1.6-1.56,.87,.01,1.56,.73,1.55,1.6-.01,.86-.73,1.56-1.6,1.55-.86-.01-1.56-.73-1.54-1.59Z"
        />
        <path
          fill={textColor}
          d="M35.22,6.2c-.63,.04-1.39-.5-1.4-1.37,0-.75,.63-1.36,1.4-1.36,.77,0,1.4,.61,1.39,1.37,0,.86-.76,1.41-1.39,1.36Z"
        />
        <path
          fill="#fffefe"
          d="M8.07,11.9c.03-1.16,.5-2.47,1.62-3.49,.64-.58,1.39-.95,2.24-1.1,1.38-.24,2.69-.07,3.87,.73,.85,.57,1.44,1.35,1.77,2.31,.52,1.5,.46,2.97-.25,4.4-.42,.85-1.06,1.5-1.89,1.96-.65,.36-1.35,.54-2.09,.58-.84,.05-1.66-.07-2.44-.41-.96-.43-1.69-1.11-2.19-2.04-.45-.81-.63-1.69-.64-2.94Zm4.92-2.76c-.07,0-.15,0-.22,0-1.02,.07-1.77,.56-2.18,1.49-.46,1.05-.43,2.13,0,3.19,.2,.5,.55,.9,1.02,1.19,.45,.27,.94,.36,1.46,.35,1.06-.01,2-.66,2.36-1.66,.3-.83,.33-1.68,.11-2.54-.3-1.21-1.25-2.05-2.56-2.02Z"
        />
        <path
          fill="#fffefe"
          d="M3.46,9.4c0-1.77,0-3.54,0-5.31,0-.13,.03-.16,.16-.16,.62,0,1.24,0,1.86,0,.12,0,.16,.03,.16,.16,0,3.31,0,6.61,0,9.92,0,.22,0,.43,.07,.64,.15,.49,.53,.77,1.07,.8,.23,.01,.45,0,.67-.05,.09-.02,.14,0,.18,.09,.22,.41,.49,.8,.8,1.14,.05,.05,.07,.07-.02,.12-.53,.3-1.1,.46-1.69,.52-.8,.09-1.56-.03-2.22-.53-.47-.36-.75-.84-.9-1.4-.1-.37-.13-.74-.13-1.12,0-1.61,0-3.21,0-4.82Z"
        />
        <path
          fill={textColor}
          d="M56.52,9.96c-.37-1.08-1.01-1.94-2.04-2.49-.97-.51-2-.63-3.07-.48-1.42,.2-2.51,.92-3.26,2.13-.91,1.47-1.04,3.07-.58,4.72,.31,1.09,.93,1.98,1.86,2.62,1.05,.73,2.24,.95,3.5,.79,1.13-.14,2.14-.58,3.04-1.27,.07-.05,.06-.09,.04-.16-.14-.38-.28-.76-.42-1.14-.04-.11-.06-.28-.14-.32-.09-.04-.21,.08-.32,.13-.94,.45-1.91,.74-2.96,.7-.36-.02-.71-.1-1.02-.27-.86-.47-1.21-1.25-1.35-2.18h.18c2.23,0,4.46,0,6.7,0,.03,0,.06,0,.08,0,.07,0,.09-.02,.09-.09,.03-.92-.03-1.82-.33-2.7Zm-2.2,1.06c-1.44,0-2.87,0-4.31,0-.1,0-.14,0-.11-.13,.26-.88,.76-1.54,1.68-1.78,.73-.19,1.44-.13,2.06,.35,.36,.28,.56,.68,.7,1.11,.04,.14,.07,.29,.11,.45h-.14Z"
        />
        <path
          fill="#ec1f25"
          d="M12.99,9.14c1.31-.02,2.25,.81,2.56,2.02,.21,.86,.19,1.7-.11,2.54-.36,1-1.3,1.65-2.36,1.66-.52,0-1.01-.08-1.46-.35-.47-.28-.81-.69-1.02-1.19-.43-1.06-.46-2.14,0-3.19,.41-.93,1.16-1.42,2.18-1.49,.07,0,.15,0,.22,0Z"
        />
      </svg>
    </span>
  );
}

export default LoLiveLogoIcon;
